import React, { useState } from "react";
import clk from "../src/images/clk.png";
import err from "../src/images/error.png";
import { useEffect } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import Footer from "./Footer";
import Pop_routes from "./Popular-routes";
import Cab_box from "./Cab-box";
import Side_fare_sum from "./Side-faresum";
import Pickupdrop from "./Pickup-drop";
import { Row, Col, Container } from "react-bootstrap";
import axios from "axios";
import Config from "./Config/Config";
import moment from "moment";
import AlertPopupMessage from "./ErrorPopus/AlertPopus";
import { BeatLoader, PropagateLoader } from 'react-spinners'
import { useConfig } from "./Context/ConfigContext";


const Cab_listing = () => {
    // called the db data from the payLoads now
    const CabListingData = JSON.parse(localStorage.getItem("cab_listing")) || {};
    const [ApiResponse, setApiResponse] = useState(null);
    const [checkSpinnerStatus, setSpinner] = useState(false);
    const { config, loading, error } = useConfig();
    const [CabSearchError , setCabSearchError] = useState(null);
    

    // check the travel root data for the now
    let travelRoot =
    CabListingData.trip_type === 'oneway' ? CabListingData.from_city?.split(',') + " | " + CabListingData.to_city?.split(',') :
    CabListingData.trip_type === 'local' ? CabListingData.from_city?.split(',') + " | " + CabListingData?.package :
        CabListingData.trip_type === 'airport' ? CabListingData.from_city?.split(',') + " | " + CabListingData.to_city :
        CabListingData.from_city?.split(',') +
        " | " +
        (
            CabListingData.travel_routes?.length === 1 ? CabListingData.travel_routes[0]?.cityInput?.split(',')[0] :
              CabListingData.travel_routes
              .map(item => item?.cityInput?.split(','))
              .join(' | ') + " | " + CabListingData.from_city?.split(',')
        )

    const currentDate = moment();
    const pichup_date = moment(CabListingData.pickup_date).isBefore(currentDate) ?
        currentDate :
        moment(CabListingData.pickup_date);

    const drop_Date = moment(CabListingData.drop_date).isBefore(currentDate) ?
        currentDate :
        moment(CabListingData.drop_date);

        const GetCabList = () => {
            // Handle travel routes for airport trips
            let formattedTravelRoute = '';
            if (CabListingData.trip_type === 'airport') {
                if (CabListingData.pickup_drop === 'pickup') {
                    formattedTravelRoute = `${CabListingData.to_city} | ${CabListingData.from_city?.split(',')}`;
                } else if (CabListingData.pickup_drop === 'drop') {
                    formattedTravelRoute = `${CabListingData.from_city?.split(',')} | ${CabListingData.to_city}`;
                }
            } else {
                // Keep existing travel route logic for other trip types
                formattedTravelRoute = 
                    CabListingData.trip_type === 'oneway' ? 
                        `${CabListingData.from_city?.split(',')} | ${CabListingData.to_city?.split(',')}` :
                    CabListingData.trip_type === 'local' ? 
                        `${CabListingData.from_city?.split(',')} | ${CabListingData?.package}` :
                        CabListingData.from_city?.split(',') +
                        " | " +
                        (CabListingData.travel_routes?.length === 1 ? 
                            CabListingData.travel_routes[0]?.cityInput?.split(',')[0] :
                            CabListingData.travel_routes
                                .map(item => item?.cityInput?.split(','))
                                .join(' | ') + " | " + CabListingData.from_city?.split(','));
            }
        
            const Payloads = {
                user_id: "",
                trip_type: CabListingData.trip_type,
                from_city_id: CabListingData.trip_type === 'airport' && CabListingData.pickup_drop === 'pickup' ? 
                    CabListingData.to_city_id :
                    CabListingData.from_city_id,
                to_city_id:  CabListingData.trip_type === 'airport' && CabListingData.pickup_drop === 'drop' ? 
                CabListingData.from_city_id :
                CabListingData.to_city_id,
                to_city: CabListingData.trip_type === 'airport' && CabListingData.pickup_drop === 'drop' ? 
                CabListingData.to_city :
                CabListingData.from_city,
                package_name: CabListingData.trip_type === "local" && 
                    CabListingData.hasOwnProperty("package") ? 
                    CabListingData.package : "",
                pickup_date: pichup_date.format("DD-MMMM-YYYY"),
                pickup_time: CabListingData.pickup_time,
                travel_route: CabListingData.trip_type === 'airport' ? formattedTravelRoute : travelRoot,
                drop_date: drop_Date.isValid() ? 
                    drop_Date.format("DD-MMMM-YYYY") : 
                    currentDate.format("DD-MMMM-YYYY"),
                airport_mode: CabListingData?.pickup_drop || "",
                drop_time: "",
                package_id: CabListingData?.package_id || "",
                page_no: "1",
                records_per_page: "100",
            };
        
            setSpinner(true);
            axios
                .post(`${Config.API_URL}/api/customer/booking/searchcab`, Payloads)
                .then((response) => {
                    if (response.data.status) {
                        setApiResponse(response.data.data);
                        if(!response.data.data){
                            setCabSearchError(response.data?.message);
                        }
                        setSpinner(false);
                    } else {
                        setApiResponse([]);
                        setCabSearchError(response.data?.message);
                        setSpinner(false);
                    }
                })
                .catch((err) => {
                    console.log(err, 'this is Error');
                    setSpinner(false);
                    setApiResponse([]);
                });
        };

    useEffect(() => {
        // called the api here
        GetCabList();
    }, []);

    // add the scroll bar on top the page reloads
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);



    const randomBookingCount = Math.floor(Math.random() * (200 - 100 + 1)) + 100;

    let airportsTravel = ''
    if (CabListingData.trip_type === 'airport') {
        if (CabListingData.pickup_drop === 'pickup') {
            airportsTravel = CabListingData.to_city + " To " + CabListingData.from_city?.split(',')[0]
        } else if (CabListingData.pickup_drop === 'drop') {
            airportsTravel = CabListingData.from_city?.split(',')[0] + " To " + CabListingData.to_city
        }
    }


    return (
        <>
            <AlertPopupMessage />
            <div className="container">
                <div className="row">
                    <div className="col-sm-8">
                        <div className="cab-book-loctn py-4">
                            <h4>
                                {CabListingData.trip_type === 'oneway' ? CabListingData.from_city?.split(',')[0] + " To " + CabListingData.to_city?.split(',')[0] :
                                    CabListingData.trip_type === 'local' ? CabListingData.from_city?.split(',')[0] + " with " + CabListingData?.package + " Package " :
                                        CabListingData.trip_type === 'airport' ?  airportsTravel :
                                        CabListingData.from_city?.split(',')[0] +
                                        "  →  " +
                                        (
                                            CabListingData.travel_routes?.length === 1 ? CabListingData.travel_routes[0]?.cityInput?.split(',')[0] :
                                              CabListingData.travel_routes
                                              .map(item => item?.cityInput?.split(',')[0])
                                              .join(' → ') + " → " + CabListingData.from_city?.split(',')[0]
                                        )
                                        } <span>{
                                                checkSpinnerStatus ?
                                                    <BeatLoader color="#185dcc" /> :
                                                    ApiResponse && ApiResponse?.length > 0 ? ApiResponse?.length : 0
                                            } Cabs available</span>
                            </h4>
                            <div className="cab-loct-info d-flex justify-content-between">
                                <h6>
                                    {" "}
                                    <img src={clk} alt="clock" title="clock" /> In 24 hours, {randomBookingCount} customers booked the Cab
                                    from this location
                                </h6>
                                <ClearIcon />
                            </div>
                            {
                            CabSearchError &&
                            <div className="cab-loct-info d-flex justify-content-between mt-2">
                                <h6>
                                    {" "}
                                    <img src={err} height={20} width={20} alt="err" title="error"/> {
                                        CabSearchError
                                    }
                                </h6>
                                <ClearIcon onClick={(e) => {
                                    e.preventDefault();
                                    setCabSearchError(null)
                                }}/>
                            </div>
                            }
                        </div>
                        <div className="row">
                            {
                                checkSpinnerStatus ?
                                    <Container>
                                        <Col className="d-flex align-items-center justify-content-center mt-5">
                                            <PropagateLoader size={24} color="#185dcc" />
                                        </Col>
                                    </Container> :
                                    !ApiResponse || ApiResponse?.length <= 0 ? (
                                        <div className="container d-flex flex-column align-items-center justify-content-center text-center p-4 border rounded-3 shadow-sm bg-light" style={{ maxWidth: '400px', marginBottom:'20px' }}>
                                            <img
                                                src="https://img.icons8.com/ios-filled/60/174EB6/car--v1.png"
                                                alt="No Cab Icon"
                                                className="mb-3"
                                            />
                                            <h3 className="mb-2" style={{ color: '#174EB6' }}>Cabs Not Found</h3>
                                            <p className="text-muted mb-2" style={{color:'#323C42' , fontSize:'16px', fontWeight:'600', lineHeight:'normal', letterSpacing:'0.8px'}}>Our cabs are not available on this route for now, Call our customer support for assistance.</p>
                                            <a
                                                href={`tel:+91${config?.company_mobile_no}`}
                                                className="hdrbtn"
                                                style={{ color:'#323C42'  , fontWeight:'600'}}
                                            >
                                                Call +91-{config?.company_mobile_no}
                                            </a>
                                        </div>
                                    ) : (
                                        ApiResponse &&  ApiResponse.map((value, index) => {
                                            return (
                                                <>
                                                    <div key={index} className="col-sm-4">
                                                        <Cab_box values={value} vahicleList={value?.vehicle_details} fairList={value?.fare_details} />
                                                    </div>
                                                </>
                                            );
                                        })
                                    )
                            }
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <Pickupdrop />
                        {/* <Side_fare_sum /> */}
                    </div>
                </div>
            </div>
            <Pop_routes />

            <Footer />
        </>
    );
};

export default Cab_listing;
